import { Module } from "vuex";
import { state } from "./state";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { IDemoState } from "@/store/modules/demo/types";
import { getters } from "@/store/modules/demo/getters";
import { RootState } from "@/store/types";

const namespaced: boolean = true;

export const demoModule: Module<IDemoState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters,
};
